import { Box, useMediaQuery, useTheme } from "@material-ui/core";
import { useState } from "react";
import { toFixed } from "src/services/utils";
import BaseOption from "../components/BaseOption";
import FigureText from "../components/FigureText";
import ReserveParameterDialog from "./ReserveParameterDialog";

export default function ReserveParameter({ asset, ...props }) {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.only("xs"));
  const [open, setOpen] = useState(false);

  function onBaseButOptionClick() {
    setOpen(true);
  }

  return (
    <>
      <BaseOption butProps={{ onClick: onBaseButOptionClick }} {...props}>
        <Box display="flex" flexWrap="wrap">
          <FigureText
            sx={{ display: "flex", alignItems: "baseline" }}
            title="Loan To Value"
            value={`${toFixed(asset.risk.maxLTV * 100, 2)}%`}
            width={matches ? "100%" : "200px"}
            mt={1}
            justifyContent={matches ? "space-between" : "flex-start"}
          />
          <FigureText
            sx={{ display: "flex", alignItems: "baseline" }}
            title="Liquidation Threshold"
            value={`${asset.risk.liqThres * 100}%`}
            width={matches ? "100%" : "200px"}
            mt={1}
            justifyContent={matches ? "space-between" : "flex-start"}
          />
          <FigureText
            sx={{ display: "flex", alignItems: "baseline" }}
            title="Reserve Factor"
            value={`${asset.risk.reserveFactor * 100}%`}
            width={matches ? "100%" : "200px"}
            mt={1}
            justifyContent={matches ? "space-between" : "flex-start"}
          />
          <FigureText
            sx={{ display: "flex", alignItems: "baseline" }}
            title="Liquidation Bonus"
            value={`${asset.risk.liqBonus * 100}%`}
            width={matches ? "100%" : "200px"}
            mt={1}
            justifyContent={matches ? "space-between" : "flex-start"}
          />
        </Box>
        <Box display="flex" flexWrap="wrap" mt={2}>
          <FigureText
            sx={{ display: "flex", alignItems: "baseline" }}
            title="Enable Borrow"
            isToggle
            value={asset.risk.enableBorrow}
            width={matches ? "100%" : "200px"}
            mt={1}
            justifyContent={matches ? "space-between" : "flex-start"}
          />
          <FigureText
            sx={{ display: "flex", alignItems: "baseline" }}
            title="Freeze Reserve"
            isToggle
            value={asset.risk.isFreezed}
            width={matches ? "100%" : "200px"}
            mt={1}
            justifyContent={matches ? "space-between" : "flex-start"}
          />
          <FigureText
            sx={{ display: "flex", alignItems: "baseline" }}
            title="Active Reserve"
            isToggle
            value={asset.risk.isActive}
            width={matches ? "100%" : "200px"}
            mt={1}
            justifyContent={matches ? "space-between" : "flex-start"}
          />
        </Box>
      </BaseOption>
      <ReserveParameterDialog asset={asset} open={open} onClose={() => setOpen(false)} />
    </>
  );
}
